module.exports = __webpack_public_path__ + "img/shop-slash.48d22caa.svg";